<template>
    <div class="participant-edit mb-3 mt-page">

        <data-form ref="dataForm"
                   :title="$i18n.gt('HEADING_EDIT_PATIENT')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="participantFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancel-route="successRoute"
                   :submit-success-message="$i18n.gt('LABEL_PATIENT_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_PATIENT')"
                   :submit-success-route="successRoute">
            <template v-slot:labelSlot="slotProps">
                <emr-lookup-participant-modal v-if="emrReadEnabled"
                                              :fieldModel="slotProps.fieldModel"
                                              :form="slotProps.form"
                                              :participant="participantId"/>
                <b-btn v-if="emrWriteEnabled && participantId && !hasEmr"
                       class="btn-secondary ml-2"
                       size="sm"
                       @click="emrCreate()">
                    {{ $i18n.gt('LABEL_EMR_CREATE') }}
                </b-btn>
            </template>
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import ParticipantFields from '@/models/Participant'

/**
 * Page to edit a Participant
 */
export default Vue.extend({
    name: 'ParticipantEdit',
    props: {
        participantId: Number,
        resellerId: Number,
        companyId: Number,
    },
    data() {
        return {
            participantFields: ParticipantFields,
            // NB: don't show contact_privacy_waived (only allow patient to edit this in profile)
            fieldGroups: [
                ['firstname', 'lastname', 'dob', 'gender', 'gender_identity', 'pronouns', 'sexual_orientation', 'ethnicity'],
                ['email', 'phone_primary', 'phone_secondary', 'preferred_contact_method'],
                ['plan_id', 'external_id', 'emr_id', 'address', 'address2', 'city', 'state', 'zip', 'disabled'],
            ],
            emrReadEnabled: false,
            emrWriteEnabled: false,
            hasEmr: false,
        }
    },
    computed: {
        successRoute() {
            if (this.$user.practitionerId()) {
                return `/participant/details/id/${this.participantId}`
            } else if (this.$user.roleIsResellerAdmin()) {
                if (this.companyId) {
                    return `/participant/resellerAdmin/${this.resellerId}/company/${this.companyId}`
                } else return `/participant/resellerAdmin/${this.$user.reseller().id}`
            } else {
                return '/participant/admin'
            }
        },
    },
    mounted() {
        this.$api.emrScope(this, {
            participant: this.participantId
        })
            .then((scope) => {
                if (scope) {
                    this.emrReadEnabled = scope.includes('patient.read')
                    this.emrWriteEnabled = scope.includes('patient.write')
                }
            })
    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'participant', this.participantId)
                .then((participant) => {
                    this.hasEmr = participant && !!participant['emr_id']
                    return participant
                })
        },
        onSubmit(modelInstance) {
            return this.$api.updateItem(this, 'participant', modelInstance)
                .then((result) => {
                    if (result && result.ok) {
                        this.$api.emrUpdate(this, 'participant', this.participantId)
                            .then((result2) => this.$utils.handleEMRError(result2))
                    }
                    if (this.$user.practitionerId()) {
                        // reload participant and surveys
                        this.$store.dispatch('getPatientParticipant', {
                            participantId: this.participantId,
                            force: true
                        })
                    }
                })
        },
        async emrCreate() {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('LABEL_EMR_CONFIRM_CREATE_PARTICIPANT'))) {
                try {
                    let result = await this.$api.emrUpdate(this, 'participant', this.participantId)
                    if (result && !this.$utils.handleEMRError(result) && result.id) {
                        if (this.$refs.dataForm && this.$refs.dataForm.form) {
                            this.$refs.dataForm.form.emr_id = result.id
                        }
                    }
                } catch (e) {
                    this.$utils.handleError(e, 'Unable to create EMR record.')
                }
            }
        },
    }
})

</script>
